export const transformToRem = (num: number) => num / 10;
